export enum ChangelogDiffType {
  BEFORE = 'before',
  AFTER = 'after',
}
